<template>
	<el-upload
		ref="upload"
		id="uploadbtn"
		:class="btnstyle"
		name="uploadAttachment"
		:auto-upload="true"
		:with-credentials="true"
		:data="uploadData"
		:headers="headers"
		:multiple="multiple"
		:action="action"
		:show-file-list="showFileList"
		:file-list="fileList"
		:accept="uploadtype"
		:disabled="disabled"
		:on-change="handleChange"
		:on-error="handleUploadError"
		:on-progress="handleProgress"
		:on-success="handleUploadSuccess"
		:before-upload="handleBeforeUpload">
		<el-button :class="classname" type="primary" :loading="loading && isLoading" size="mini"><span v-if="buttonText">{{(loading && isLoading)?'上传中':buttonText}}</span></el-button>
	</el-upload>
</template>

<script>
	/**
	 * @name:按钮式文件上传组件
	 * @createdby:cjf
	 * @depend elementUI
	 * @demo：<lnk-upload-button-img
	 :head-id="headId"
	 button-text="上传文件"
	 btnstyle="btncrm"
	 module-type="SALE_CAMP"
	 @uploadsuccess="uploadSuccess">
	 </lnk-upload-button-img>
	 *@function
	 * uploadSuccess: function(data){
	 *      //获取附件id
	 *      this.$meessage.success({type:'success',message:'文件上传成功'})
            this.formData.attachmentId = data.newRow.id;
       },
	 @head-id: 附件图片所属对象id（必填）
	 @module-type: 附件所属对象业务编码 （必填）
	 @image-size: 上传图片大小限制，默认2048（KB）
	 @disabled：是否禁用 true/false（可用）
	 @image-url: 要显示图片的URL
	 @uploadsuccess: 上传成功回调函数，参数为上传成功后服务端返回的对象
	 @para:回传的自定义参数
	 uploadtype:上传文件的类型，可自定义文件格式 例子: uploadtype=".doc,.pptx,.png,jpg"
	 button-text:可选项，按钮的显示文字，默认为‘上传文件’
	 btnstyle:按钮样式，可选值 btncrm btndms 默认值 btncrm
	 :show-file-list : 是否显示已上传文件列表，默认为false

	 // 以下注释可满足图片上传大小宽度像素所使用
	 :is-limit-size : 是否可限制图片上传的长宽像素限制 默认 不限制 如果要限制长宽 可自行设置以下属性
	 :img-width: 上传图片的长度 单位:像素 默认 1080
	 :img-height: 上传图片的长度 单位:像素 默认 864


	 */

	export default {
		name: 'lnk-upload-button-img',
		props: {
			headId: String, // 上传文件关联头id
			moduleType: String, // 上传文件业务模块编码
			imageSize: {
				type: Number,
				default: 2048
			},
			buttonText: {
				type: String,
				default: '上传图片'
			},
			classname: {
				type: String,
				default: ''
			},
			para: {
				type: Object,
				default: undefined
			},
			loading: {
				type: [Boolean, String],
				default: true
			},
			imgWidth: { // 限制图片上传的宽度像素px
				type: Number,
				default: 1080
			},
			imgHeight: { // 限制图片上传的高度像素px
				type: Number,
				default: 864
			},
			isLimitSize: {
				type: Boolean,
				default: false
			},
			multiple: {         // 是否支持多选文件
				type: Boolean,
				default: false
			},
			uploadtype: {
				type: String,
				default: '.png,.jpg,.jpeg'
			},
			// 按钮颜色样式
			btnstyle: {
				type: String,
				default: 'btncrm'
			},
			beforeUpload: {
				type: Function,
				default: function(){
					return true;
				}
			},
			showFileList: {// 是否显示显示已上传文件列表
				type: Boolean,
				default: false
			},
			imageUrl: String,
			disabled: Boolean,
			uploadTitle: String,
          	action: {
            	type: String,
            	default: () => appCtx.ctxPath + `/action/${LinkVue.prefixUrl}/attachment/insert` // 附件上传路径
          	}
		},
		data: function(){
			return {
				headers: {
					// 文件上传请求头
					Authorization: linkToken.getLocalToken()
				},
				uploadData: {
					// 上传文件额外参数
					headId: this.headId, // 关联头id
					moduleType: this.moduleType // 业务模块类型
				},
				// action: appCtx.ctxPath+ '/action/link/attachment/insert', // 附件上传路径
				isLoading: false,
				fileList: [],
				isShowLoading: true,
				uploadFileList: []              // 多选情况下上传的文件列表
			};
		},
		watch: {
			headId: {
				immediate: true,
				handler: function () {
					this.uploadData.headId = this.headId;
				}
			},
			moduleType: {
				immediate: true,
				handler: function () {
					this.uploadData.moduleType = this.moduleType;
				}
			}
		},
		methods: {
			handleBeforeUpload: function(file){
				var istrue = true;
				var ishavefile = false;
				var typeLimit=this.uploadtype.replace(/,/g, '').split('.');
				var changeArr = typeLimit.filter((d) => d);
				var limitSize = file.size / 1024 < this.imageSize;
				var fileType = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
				for(var i = 0; i < changeArr.length; i++){
					if(fileType.indexOf(changeArr[i].toLowerCase())!=-1){
						istrue = true;
						ishavefile = true;
						break;
					}else{
						istrue = false;
						ishavefile = false;

					}
				}
				if(!ishavefile){
					this.$message.error('不是支持的文件类型!');
					return;
				}
				if(!limitSize){
					this.$message.error('上传文件大小不能超过 '+this.imageSize+'KB!');
					return;
				}
				// 以下代码为上传组件是否要限制图片像素功能使用
				var isCanUpload = true;
				if(this.isLimitSize){
					var that = this;
					var width = this.imgWidth;
					var height = this.imgHeight;
					const isSize = new Promise((resolve, reject) => {
						const imgUrl = window.URL || window.webkitURL;
						const img = new Image();
						img.onload = function() {
							const valid = img.width == width && img.height == height;
							valid ? resolve() : reject();
						};
						img.src = imgUrl.createObjectURL(file);
					}).then(() => {
						isCanUpload = true;
						that.beforeValidateUpload(istrue, limitSize, isCanUpload, file);
					}, () => {
						var msg = '上传的图片像素必须是等于'+width+'*'+height+'!';
						that.$message.error(msg);
						isCanUpload = false;
						that.beforeValidateUpload(istrue, limitSize, isCanUpload, file);
					});
				}else{
					this.beforeValidateUpload(istrue, limitSize, isCanUpload, file);
				}
			},

			handleChange(file){
				this.$emit('on-change', '');
			},
			/**
			 *@createdBy 常九福
			 *@date 2018/12/6
			 *@methods:beforeValidateUpload
			 *@para: istrue 是否是自己上传的图片类型
			 *       limitSize  是否满足上传文件类型大小限制
			 *       isCanUpload 增加图片限制宽高是否通过
			 *       file 上传的文件对象
			 *@description:上传前校验是否通过
			 **/
			beforeValidateUpload(istrue, limitSize, isCanUpload, file){
				var isupload = istrue&&limitSize&&isCanUpload ? true: false;
				if(isupload == true){
					this.isShowLoading = true;
					return this.beforeUpload(file);
				}else{
					this.$message.error('上传校验不通过');
					this.isShowLoading = false;
					this.$refs.upload.abort();
				}
			},
			handleProgress: function(event, file, fileList){
				if(this.isShowLoading){
					this.isLoading=true;
				}
			},
			handleUploadSuccess: function(response, file, fileList){
				this.isLoading=false;
				// 上传成功回调
				if(response.success){
					if(this.para){
						response.para=this.para;
					}
					if (this.multiple)  {
						this.uploadFileList.push(response);
						if (this.uploadFileList.length == fileList.length){
							this.$emit('uploadsuccess', this.uploadFileList);
							setTimeout(()=> {
								this.uploadFileList = [];
								this.fileList = [];
							}, 500);
						}
					}
					else this.$emit('uploadsuccess', response);
				} else{
					this.$message.error('上传失败: '+response.result);
				}
				this.$emit('uploadfinish', response);
			},
			handleUploadError: function(file){
				// 上传失败
				this.$message.error('上传失败');
				this.isLoading=false;
			}

		}
	};
</script>

<style>
	/*crm按钮颜色*/
	.btncrm .el-button{
		background-color:#1F74FF ;
		border-color:#1F74FF ;
	}
	/*dms按钮颜色*/
	.btndms .el-button{
		background-color:#409eff;
		border-color:#409eff;
	}
</style>
